import type { TBlueTable, TBlueObj } from "@app/types/insider";
import type { IListofContacts } from "@app/types/insider";

const contactListmapWrite = (item) => ({
  C_ID: item.C_ID,
  DENUMIRE: item.DENUMIRE,
  LEGAL_FORM: item.LEGAL_FORM,
  ADRESE: `${item.ADRESE_1 || ""}${item.ADRESE_2 || ""}${item.ADRESE_3 || ""}`,
  TELEFON: item.TELEFON,
  FAX: item.FAX,
  EMAIL: item.EMAIL,
  WEB_SITE: item.WEB_SITE,
  OBSERVATII: item.OBSERVATII,
  CERINTE_SPECIALE: item.CERINTE_SPECIALE,
  DT_INSERTED: item.DT_INSERTED,
  AVO_INSERTED: item.AVO_INSERTED,
  DT_UPDATED: item.DT_UPDATED,
  AVO_UPDATED: item.AVO_UPDATED,
  NR_INREG: item.NR_INREG,
  CIF: item.CIF,
  IBAN: item.IBAN,
  BANCA: item.BANCA,
});

export const contactlist: TBlueTable<IListofContacts> = {
  name: "contactlist",
  empty: {} as IListofContacts,
  initialState: {},
  primaryKey: "C_ID",
  apiUrl: "/select/ss_listOf_contacts",
  pkeyUrl: null, //todo lexy (A-F, G-L, M-R, S-Z)
  mapWrite: contactListmapWrite,
  mapRead: (data) => data,
  bootPriority: 1,
  starfx: true,
  idb: true,
  starfx_index: "C_ID",
  idb_indexes: [],
  onmru: "no",
  oncsdb: "no",
  label: "Contacte",
  appContext: [],
};
